<template>
        <div class="w100 pl10 pr10 pb10 " v-loading="loading">
            <div class="table-con">
                <div v-if="!postId" class="no-data">未选择岗位</div>
                <el-table v-if="postId" class="w100 mt20 table" header-row-class-name="table-head"
                          row-class-name="cu-p" stripe :data="list" height="calc(100vh - 250px)">

                    <el-table-column align="center" prop="username" width="200px" label="名称"></el-table-column>
                    <el-table-column align="center" prop="sex" width="200px" label="性别">
                        <template slot-scope="scope">
                            <span v-if="scope.row.sex+''=='1'">男</span>
                            <span v-if="scope.row.sex+''=='0'">女</span>
                            <span v-if="scope.row.sex+''=='null'">未知</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" prop="userDeptName" width="200px" label="人员所属部门"></el-table-column>
                    <el-table-column align="center" prop="belongDeptName" width="200px" label="岗位所属部门"></el-table-column>
                    <el-table-column align="center" prop="phone" min-width="200px" label="手机"></el-table-column>
                    <el-table-column align="center" width="150px" label="操作" fixed="right">
                        <template slot-scope="scope">
                            <div class="to-use">
                                <span class="info" @click="switchJobFn(scope.row)">调岗</span>
                                <span class="danger" @click="deleteFn(scope.row.postUserId)">移出</span>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <div v-if="postId" class="mt20 flex-box">
                <div class="flex-1"></div>
                <el-pagination background @size-change="changeSize"
                               @current-change="changePage"
                               :current-page="paramSearch.current"
                               :page-sizes="pageSizes"
                               :page-size="paramSearch.size"
                               layout="total, sizes, prev, pager, next, jumper"
                               :total="total"
                ></el-pagination>
            </div>
            <switchJob ref="switchJob" @saveSuccess="saveSuccess"/>
        </div>
</template>

<script>
    import { gettHallPostpage,handleOut} from '@/api/managementCenter/jobManage';
    import switchJob from "@/components/management/job/switchJob";
    export default {
        name: "rightList",
        components: {
            switchJob
        },
        data(){
            return {
                loading:false,
                list: [],
                pageSizes:[ 20, 30, 50, 100],
                paramSearch:{
                    current:1,
                    size:20
                },
                total: 0,
                postId:''
            }
        },
        methods:{
            loadListFn(postId){
                this.postId=postId;
                if(this.postId){
                    this.getListFn();
                }
            },
            // 获取查询列表
            getListFn () {
                this.list = [];
                this.total = 0;
                this.loading = true;
                gettHallPostpage({...this.paramSearch,postId:this.postId})
                    .then(({data})=> {
                    this.loading = false;
                    if(data.code == 0){
                        this.list = data.data.records || [];
                        this.total = data.data.total;
                    }
                }).catch(() => {
                        this.loading = false;
               });
            },
            // 条数
            changeSize(value) {
                this.paramSearch.size=value;
                this.paramSearch.current=1;
                this.getListFn();
            },
            // 翻页
            changePage(value) {
                this.paramSearch.current=value;
                this.getListFn();
            },
            openDetail(){
                this.$emit('openDetail')
            },
            // 删除
            deleteFn (id) {
                this.$confirm( "是否确定移出?", "提示", {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.deleteHttp(id)

                }).catch(() => {
                    this.$message.info( "已取消移出" );

                });
            },
            deleteHttp(id){
                this.loading = true;
                // 删除接口
                handleOut(id).then( ({data}) => {
                    this.loading = false;
                    if(data.code == 0){
                        this.$message.success("移出成功!" );
                        this.getListFn();
                    }else{
                        this.$message.warning( data.msg||"移出失败！" );
                    }
                }).catch(() => {
                    this.loading = false;
                    this.$message.error( "移出异常!" );
                });
            },
            switchJobFn(item){
                this.$refs.switchJob.dialogShow(item)
            },
            saveSuccess(){
                this.getListFn();
            }
        }
    }
</script>

<style scoped  lang="less">
    @import "../../../assets/css/handleBtn.less";
    /*/deep/.el-table {*/
        /*width: 100%;*/
        /*.el-table__body-wrapper {*/
            /*max-height: calc(100vh - 290px);*/
            /*overflow-y: auto;*/

        /*}*/
    /*}*/
</style>
